import { z } from 'zod';

export const WarrantyCoverageStatusSchema = z.string();

export type WarrantyCoverageStatus = z.infer<
  typeof WarrantyCoverageStatusSchema
>;

export enum KnownWarrantyCoverageStatus {
  NO_DATA = 'No Data',
  VALID = 'Valid',
  EXPIRED = 'Expired',
  CASE_OPEN = 'Case Open',
}

export function isKnownWarrantyCoverageStatus(
  status: WarrantyCoverageStatus,
): status is KnownWarrantyCoverageStatus {
  return (Object.values(KnownWarrantyCoverageStatus) as string[]).includes(
    status,
  );
}
